import React, { useEffect, useState } from "react";

import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";
import Modal from "../../components/UI/Modal";

import CronSelector from "./CronSelector";
import WeekTabs from "./WeekTabs";
import TemplateEditor from "./TemplateEditor";
import { previewCronTemplate } from "../../services/cronTemplateService";

import {
  fetchCronTemplates,
  updateCronTemplate,
  createCronTemplate
} from "../../services/cronTemplateService";
import { CRON_TYPES } from "../../config/cronTypes";

const CronTemplatesPage = () => {

  const [cronType, setCronType] = useState(CRON_TYPES[0].value);
  const [templates, setTemplates] = useState([]);
  const [activeWeek, setActiveWeek] = useState(1);

  const [previewHtml, setPreviewHtml] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);

  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(false);

  useEffect(() => {

    // reset UI when cron changes
    setTemplates([]);
    setActiveWeek(1);

    loadTemplates();

  }, [cronType]);

  
  const openPreview = async () => {

    const res = await previewCronTemplate(
      cronType,
      activeWeek
    );

    setPreviewHtml(res.data.html);
    setPreviewOpen(true);
  };


  const loadTemplates = async () => {

    // const [loading, setLoading] = useState(false);
    // setLoading(false);

    const res = await fetchCronTemplates(cronType);

    const data = Array.isArray(res.data) ? res.data : res.data.results || [];

    const weeks = [1, 2, 3, 4];

    const filled = weeks.map((week) => {
      const existing = data.find(t => t.week_number === week);

      if (existing) return existing;

      return {
        id: null,
        week_number: week,
        subject: "",
        html_content: ""
      };
    });

    setTemplates(filled);
    // setLoading(true);
  };

  const activeTemplate = templates.find(
    (t) => t.week_number === activeWeek
  );

  const updateLocalTemplate = (field, value) => {

    const updated = templates.map((t) => {
      if (t.week_number === activeWeek) {
        return { ...t, [field]: value };
      }
      return t;
    });

    setTemplates(updated);
  };

  const saveTemplate = async () => {

    if (!activeTemplate) return;

    if (activeTemplate.id) {

      await updateCronTemplate(activeTemplate.id, {
        subject: activeTemplate.subject,
        html_content: activeTemplate.html_content
      });

    } else {

      const res = await createCronTemplate({
        cron_type: cronType,
        week_number: activeWeek,
        subject: activeTemplate.subject,
        html_content: activeTemplate.html_content,
        is_active: true
      });

      loadTemplates();
    }

    setShowModal(true);
  };


  return (

    <div className="space-y-6">

      {loading && <div>Loading templates...</div>}

      <Card>

        <h2 className="text-xl font-semibold mb-4">
          Cron Email Templates
        </h2>

        <CronSelector
          cronType={cronType}
          setCronType={setCronType}
        />

      </Card>

      <Card>

        <WeekTabs
          activeWeek={activeWeek}
          setActiveWeek={setActiveWeek}
        />

        {activeTemplate && (

          <TemplateEditor
            template={activeTemplate}
            onChange={updateLocalTemplate}
          />

        )}

        <div className="mt-4">

          <div className="flex gap-3 mt-4">

            <Button onClick={saveTemplate}>
              Save Template
            </Button>

            <Button variant="secondary" onClick={openPreview}>
              Preview
            </Button>

          </div>

        </div>

      </Card>

      <Modal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        title="Template Saved"
        footer={
          <Button
            variant="primary"
            onClick={() => setShowModal(false)}
          >
            OK
          </Button>
        }
      >
        Template saved successfully.
      </Modal>

      <Modal
        isOpen={previewOpen}
        onClose={() => setPreviewOpen(false)}
        title="Email Preview"
        footer={
          <Button onClick={() => setPreviewOpen(false)}>
            Close
          </Button>
        }
      >

        <div
          className="max-h-[500px] overflow-y-auto"
          dangerouslySetInnerHTML={{ __html: previewHtml }}
        />

      </Modal>

    </div>

  );
};

export default CronTemplatesPage;